import { useQuery } from "@tanstack/react-query";
import { settlementsApi } from "../api";

/**
 * Hook compartido entre las 5 sub-tabs que consumen el endpoint
 * dashboard-buckets. React Query dedupea el fetch entre sub-tabs montadas.
 *
 * staleTime corto (15s) porque los settlements cambian con frecuencia
 * (cron de timeout cada hora, aceptaciones manuales, transferencias).
 */
export function useBuckets() {
  return useQuery({
    queryKey: ["settlements", "dashboard-buckets"],
    queryFn: () => settlementsApi.dashboardBuckets(),
    staleTime: 15_000,
    refetchInterval: 60_000,
  });
}
